<div class="fuse-vertical-navigation-wrapper">
    <!-- Header -->
    <div class="fuse-vertical-navigation-header">
        <ng-content select="[fuseVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div class="fuse-vertical-navigation-content pb-8" fuseScrollbar [fuseScrollbarOptions]="{
            wheelPropagation: inner,
            suppressScrollX: true
        }" #navigationContent>
        <!-- Content header -->
        <div class="fuse-vertical-navigation-content-header">
            <ng-content select="[fuseVerticalNavigationContentHeader]"></ng-content>
        </div>

        <!-- Items -->
        <ng-container *ngFor="
                let item of filteredNavigation;
                trackBy: trackByFn;
                let isFirst = first;
                let isLast = last
            ">
            <!--** Card Advertising -->
            <!-- <ng-container *ngIf="isFirst">
                <a
                    [routerLink]="['/product/37']"
                    routerLinkActive="router-link-active"
                >
                    <div
                        class="w-70 overflow-hidden bg-white m-2 rounded-md cursor-pointer"
                    >
                        <app-sidebar></app-sidebar>
                    </div>
                </a>
            </ng-container> -->
            <!--** Card Advertising -->
            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">
                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside'">
                    <fuse-vertical-navigation-aside-item [item]="item" [name]="name" [activeItemId]="activeAsideItemId"
                        [autoCollapse]="autoCollapse" [skipChildren]="true"
                        (click)="toggleAside(item)"></fuse-vertical-navigation-aside-item>
                </ng-container>

                <!-- Basic -->
                <!-- ** item.id venant de data common/navigation  -->
                <ng-container *ngIf="item.type === 'basic' && item.id != 'boutique'">
                    <fuse-vertical-navigation-basic-item [item]="item"
                        [name]="name"></fuse-vertical-navigation-basic-item>
                </ng-container>

                <!-- ** Ma boutique lien externe via ce containger  -->
                <ng-container *ngIf="item.id === 'boutique'">
                    <div (click)="onClick()">
                        <fuse-vertical-navigation-basic-item [item]="item"
                            [name]="name"></fuse-vertical-navigation-basic-item>
                    </div>
                </ng-container>

                <!-- Collapsable -->
                <ng-container *ngIf="item.type === 'collapsable'">
                    <fuse-vertical-navigation-collapsable-item [item]="item" [name]="name"
                        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-collapsable-item>
                </ng-container>

                <!-- Divider -->
                <ng-container *ngIf="item.type === 'divider'">
                    <fuse-vertical-navigation-divider-item [item]="item"
                        [name]="name"></fuse-vertical-navigation-divider-item>
                </ng-container>

                <!-- Group -->
                <ng-container *ngIf="item.type === 'group'">
                    <fuse-vertical-navigation-group-item [item]="item" [name]="name"
                        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-group-item>
                </ng-container>

                <!-- Spacer -->
                <ng-container *ngIf="item.type === 'spacer'">
                    <fuse-vertical-navigation-spacer-item [item]="item"
                        [name]="name"></fuse-vertical-navigation-spacer-item>
                </ng-container>
            </ng-container>
        </ng-container>

        <div class="mt-6 mb-3 w-full flex flex-col justify-center items-center">
            <div class="flex">
                <div class="mr-2 mt-0.5 uppercase sm:whitespace-nowrap">
                    Parrain de l'app.
                </div>
                <mat-icon class="text-accent heart-animation text-sm" [svgIcon]="'heroicons_solid:heart'"></mat-icon>
            </div>
          <div class="mt-3">
    <app-logo-parrain
        context="sidebar"
        [useMainSponsor]="true"
        customClass="cursor-pointer"
        (parrainClicked)="onShowParrainSpace($event)"
    ></app-logo-parrain>
</div>
        </div>
        <!-- Content footer -->
        <div class="fuse-vertical-navigation-content-footer">
            <ng-content select="[fuseVerticalNavigationContentFooter]"></ng-content>
        </div>
    </div>

    <!-- Footer -->
    <div class="fuse-vertical-navigation-footer">
        <ng-content select="[fuseVerticalNavigationFooter]"></ng-content>
    </div>
</div>

<!-- Aside -->
<ng-container *ngIf="activeAsideItemId">
    <div class="fuse-vertical-navigation-aside-wrapper" fuseScrollbar [fuseScrollbarOptions]="{
            wheelPropagation: false,
            suppressScrollX: true
        }" [@fadeInLeft]="position === 'left'" [@fadeInRight]="position === 'right'"
        [@fadeOutLeft]="position === 'left'" [@fadeOutRight]="position === 'right'">
        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">
            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">
                <!-- Aside -->
                <ng-container *ngIf="
                        item.type === 'aside' && item.id === activeAsideItemId
                    ">
                    <fuse-vertical-navigation-aside-item [item]="item" [name]="name"
                        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-aside-item>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-container>